/* Kindly v2 — vitamines-rail: doorschuiven met de pijlknoppen of de
 * pijltoetsen, en een kaart oplichten door erop te klikken. Swipen doet de
 * browser zelf, want de rail is een gewoon scrollspoor met snap-punten.
 */
(function () {
  'use strict';

  function init(section) {
    if (section.__kv2Rail) return;
    section.__kv2Rail = true;

    var rail = section.querySelector('[data-kv2-rail]');
    if (!rail) return;

    var cards = Array.prototype.slice.call(section.querySelectorAll('[data-kv2-card]'));
    var prev = section.querySelector('[data-kv2-rail-prev]');
    var next = section.querySelector('[data-kv2-rail-next]');

    // Welke kaart staat er nu vooraan? Bij links uitlijnen vergelijken we de
    // linkerrand van de kaart met de scrollpositie; bij centreren de middens.
    // Beide met dezelfde maatstaf, anders blijft de rail na één klik hangen.
    function centeredIndex() {
      var pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
      var ref = alignStart
        ? rail.scrollLeft + pad
        : rail.scrollLeft + rail.clientWidth / 2;
      var best = 0;
      var bestDist = Infinity;
      cards.forEach(function (card, i) {
        var point = alignStart ? card.offsetLeft : card.offsetLeft + card.offsetWidth / 2;
        var dist = Math.abs(point - ref);
        if (dist < bestDist) { bestDist = dist; best = i; }
      });
      return best;
    }

    // Uitlijnen: gecentreerd, of links met dezelfde inspringing als de rail.
    var alignStart = section.hasAttribute('data-kv2-rail-noselect');

    function scrollToCard(index) {
      if (index < 0) index = 0;
      if (index > cards.length - 1) index = cards.length - 1;
      var card = cards[index];
      if (!card) return;
      var pad = parseFloat(getComputedStyle(rail).scrollPaddingLeft) || 0;
      rail.scrollTo({
        left: alignStart
          ? Math.max(0, card.offsetLeft - pad)
          : card.offsetLeft - (rail.clientWidth - card.offsetWidth) / 2,
        behavior: 'smooth'
      });
    }

    function updateArrows() {
      // Past alles binnen de rail, dan valt er niets te schuiven en zijn de
      // pijlen misleidend; die verdwijnen dan helemaal.
      var scrollable = rail.scrollWidth - rail.clientWidth > 4;
      section.setAttribute('data-scrollable', scrollable ? 'true' : 'false');
      if (prev) prev.disabled = !scrollable || rail.scrollLeft <= 4;
      if (next) next.disabled = !scrollable || rail.scrollLeft >= rail.scrollWidth - rail.clientWidth - 4;
    }

    if (prev) prev.addEventListener('click', function () { scrollToCard(centeredIndex() - 1); });
    if (next) next.addEventListener('click', function () { scrollToCard(centeredIndex() + 1); });

    rail.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); scrollToCard(centeredIndex() - 1); }
      if (e.key === 'ArrowRight') { e.preventDefault(); scrollToCard(centeredIndex() + 1); }
    });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(updateArrows);
    }, { passive: true });

    function toggle(card) {
      var on = card.getAttribute('data-selected') !== 'true';
      cards.forEach(function (c) {
        c.setAttribute('data-selected', 'false');
        c.setAttribute('aria-pressed', 'false');
      });
      card.setAttribute('data-selected', on ? 'true' : 'false');
      card.setAttribute('aria-pressed', on ? 'true' : 'false');
    }

    // Sommige rails zijn puur om doorheen te schuiven; daar licht een kaart niet op.
    if (!section.hasAttribute('data-kv2-rail-noselect')) {
      cards.forEach(function (card) {
        card.addEventListener('click', function () { toggle(card); });
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(card); }
        });
      });
    }

    updateArrows();
    window.addEventListener('resize', updateArrows);
  }

  function boot() {
    document.querySelectorAll('[data-kv2-rail-section]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
